import Cookies from 'js-cookie'

const TOKEN_KEY = 'Admin-Token'
const REFRESH_TOKEN_KEY = 'Admin-Refresh-Token'

export function getToken() {
  return Cookies.get(TOKEN_KEY) || localStorage.getItem('_token_') || ''
}

export function setToken(token) {
  localStorage.setItem('_token_', token)
  return Cookies.set(TOKEN_KEY, token, { sameSite: 'Lax' })
}

export function removeToken() {
  localStorage.removeItem('_token_')
  return Cookies.remove(TOKEN_KEY)
}

export function getRefreshToken() {
  return Cookies.get(REFRESH_TOKEN_KEY) || localStorage.getItem('_refreshToken_') || ''
}

export function setRefreshToken(token) {
  if (!token) return
  localStorage.setItem('_refreshToken_', token)
  return Cookies.set(REFRESH_TOKEN_KEY, token, { sameSite: 'Lax' })
}

export function removeRefreshToken() {
  localStorage.removeItem('_refreshToken_')
  return Cookies.remove(REFRESH_TOKEN_KEY)
}
